import React from 'react';
import PropTypes from 'prop-types';
import { LedgerEntryType } from '../../common/Helpers';
import { getFlagTag, parseMPTokenFlags } from '../../common/FlagHelpers';
import { FormattedNumber } from 'react-intl';

const MPToken = (props) => {
    const { node } = props;

    if ( node?.LedgerEntryType === LedgerEntryType.MPToken ) {
        return (
            <>
                {node?.MPTokenIssuanceID &&
                <tr>
                    <td>MPTokenIssuanceID:</td>
                    <td className='text-muted text-monospace'>
                        {node.MPTokenIssuanceID}
                    </td>
                </tr>
                }
                {node?.MPTAmount >= 0 &&
                <tr>
                    <td>MPTAmount:</td>
                    <td className='text-monospace'>
                        <FormattedNumber value={node.MPTAmount}/>
                    </td>
                </tr>
                }
                {node?.LockedAmount >= 0 &&
                <tr>
                    <td>LockedAmount:</td>
                    <td className='text-monospace'>
                        <FormattedNumber value={node.LockedAmount}/>
                    </td>
                </tr>
                }

                {node?.Flags > 0 &&
                <tr>
                    <td>Flags:</td>
                    <td>
                        {getFlagTag(node.Flags, parseMPTokenFlags)}
                    </td>
                </tr>
                }
            </>
        );    
    } else {
        return <></>;
    }
}

MPToken.propTypes = {
    node: PropTypes.object,
}

export default MPToken;